module.exports = __webpack_public_path__ + "static/img/yaoqing.8e42ac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/yaoqing.png
// module id = y8NT
// module chunks = 24